import { FullScreenOverlayDiv } from './style';

export interface IFullScreenOverlay {
  children: React.ReactNode;
}

export function FullScreenOverlay({ children }: IFullScreenOverlay) {
  return <FullScreenOverlayDiv>{children}</FullScreenOverlayDiv>;
}
